import { Button, WidgetDropDownSingleValue, WidgetInput, } from '@yellowcard/components-library-vue3';
import { computed, defineComponent, nextTick, onMounted, ref, watch, watchEffect, } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
import validator from 'validator';
import { CountryTypes } from '@/types/country';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import { postalCodeIsInvalid, streetIsInvalid } from '@/utils/helpers';
import useTransactionsStore from '@/store/modules/transactions';
export default defineComponent({
    name: 'ResidentialDetails',
    props: {},
    components: {
        Button,
        WidgetInput,
        WidgetDropDownSingleValue,
    },
    setup() {
        const kycStore = useKycStore();
        const { currentStep, residentialDetails: userInput, statesCities, statesRefreshKey, } = storeToRefs(kycStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const transactionsStore = useTransactionsStore();
        const { countryConfig, activeSupportedCountryConfig } = storeToRefs(transactionsStore);
        const { country: configCountry } = countryConfig.value;
        const isButtonDisabled = ref(true);
        const cities = ref([]);
        const states = computed(() => statesCities.value.map(sc => sc.name));
        const rules = computed(() => ({
            // remove error messages while confirming correct error state
            street: (value) => {
                if (validator.isEmpty(value) || streetIsInvalid(value))
                    return ' ';
                return true;
            },
            state: (value) => {
                if (validator.isEmpty(value || ''))
                    return ' ';
                return true;
            },
            city: (value) => {
                if (validator.isEmpty(value || ''))
                    return ' ';
                return true;
            },
            country: (value) => {
                if (validator.isEmpty(value || ''))
                    return ' ';
                return true;
            },
            postalCode: (value) => {
                if (validator.isEmpty(value) || postalCodeIsInvalid(value))
                    return ' ';
                return true;
            },
        }));
        const countries = computed(() => [
            activeSupportedCountryConfig.value?.countryName,
        ]);
        const backClick = () => {
            currentStep.value = KycTypes.KycSteps.KYC_2;
        };
        const validateInputs = (newInput) => !(rules.value.street(newInput.street) === true &&
            rules.value.state(newInput.state) === true &&
            rules.value.city(newInput.city) === true &&
            rules.value.country(newInput.country) === true &&
            rules.value.postalCode(newInput.postalCode) === true);
        const getCities = () => {
            if (userInput.value.state) {
                const cityValues = statesCities.value.find(state => state.name === userInput.value.state)?.cities;
                cities.value.splice(0);
                cities.value.push(...(cityValues ?? []));
            }
            else {
                userInput.value.city = '';
                cities.value.splice(0);
            }
        };
        onMounted(() => {
            getCities();
            isButtonDisabled.value = validateInputs(userInput.value);
        });
        watch(userInput.value, newInput => {
            nextTick(() => {
                isButtonDisabled.value = validateInputs(newInput);
            });
        }, { deep: true });
        watchEffect(() => {
            getCities();
        });
        const citySelect = (value) => {
            userInput.value.city = value;
        };
        const stateSelect = (value) => {
            userInput.value.state = value;
            if (countryConfig.value.country !== CountryTypes.CountryCodes.NIGERIA) {
                return;
            }
            if (userInput.value.state !== value) {
                userInput.value.city = '';
            }
        };
        const countrySelect = (value) => {
            userInput.value.country = value;
        };
        const proceed = () => {
            userInput.value.country = activeSupportedCountryConfig.value.countryName;
            const { street, state, city, country, postalCode } = userInput.value;
            trackEvent(MIXPANEL_EVENTS.KYC.ADDRESS, {
                partner: partnerId.value,
            });
            authStore.setResidentialDetails({
                street,
                state,
                city,
                country,
                postalCode,
            });
            currentStep.value = KycTypes.KycSteps.KYC_4;
        };
        const onKeyPress = () => {
            console.log('key pressed');
        };
        return {
            backClick,
            countries,
            userInput,
            rules,
            proceed,
            isButtonDisabled,
            onKeyPress,
            citySelect,
            stateSelect,
            statesRefreshKey,
            countrySelect,
            configCountry,
            states,
            cities,
            CountryTypes,
        };
    },
});
